import registerreducer from './register-reducer';

export default registerreducer;
